<template>
  <div>
    <el-row>
      <el-col v-if="slid" class="lefttreeBody" :span="3">
        <img src="http://120.79.200.17:19002/static/image/%E7%A7%91%E6%8A%80%E8%93%9D/arrow/arrow_left.png"
          class="showTreeIcon" @click="slid = !slid" />
        <div>
          <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick">
            <template #default="scope">
              <el-col :span="20">
                <img style="width: 25px;height: 15px;padding-right: 8px;"
                  src="http://120.79.200.17:19002/static/image/%E7%A7%91%E6%8A%80%E8%93%9D/tree/node_class.png" />
                <span>{{ scope.data.label }}</span>
              </el-col>
            </template>
          </el-tree>
        </div>
      </el-col>
      <el-col v-if="!slid" class="lefttreeBody" :span="0.5">
        <img src="http://120.79.200.17:19002/static/image/%E7%A7%91%E6%8A%80%E8%93%9D/arrow/arrow_right.png"
          class="showTreeIcon" @click="slid = !slid" />
      </el-col>
      <el-col :span="slid ? '20' : '23'">
        <el-table :data="blogData" border :fit='true' :header-cell-style="{background: 'rgb(241, 244, 247)'}"
          style="width: 100%">
          <el-table-column type="index" align="center" width="50">
          </el-table-column>
          <el-table-column prop="data" label="数据项" align="center">
          </el-table-column>
          <el-table-column prop="value" label="值" align="center">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        clientHeight: "",
        slid: true,
        data: [
          {
            label: "一级 1",
            children: [
              {
                label: "二级 1-1",
                children: [
                  {
                    label: "三级 1-1-1",
                  },
                ],
              },
            ],
          }],
        blogData: [{
          data: '是否告警',
          value: '否'
        },{
          data: '总支路数',
          value: '16'
        },{
          data: 'E-01-A-1汇流箱.第1路电流',
          value: '0.17'
        }],
        defaultProps: {
          children: "children",
          label: "label",
        },
      };
    },
    methods: {
      handleNodeClick (data) {
        console.log(data);
      },
    },
    mounted () {

    },
  };
</script>

<style scoped>
  .lefttreeBody {
    background-size: 100% 100%;
    overflow: hidden;
    background: #e3e9ee;
  }

  .showTreeIcon {
    width: 40px;
    height: 38px;
    padding: 0.2rem 0.12rem 0px 0.1rem;
    display: inline-block;
    cursor: pointer;
    /* animation: 0.5s ease 0s infinite alternate none running; */
    padding: 20px 12px 0 10px;
    animation: hh 1s linear infinite;
  }

  .showTreeIcon:hover {
    animation-play-state: paused;
  }

  .tree-part {
    min-width: 2.2rem;
    max-width: 2.2rem;
    width: 2.2rem;
    height: calc(100% - 28px);
  }

  .el-tree {
    background: #e3e9ee;
  }

  @keyframes hh {
    0% {
      transform: translateX(0);
    }

    50% {
      transform: translateX(10px);
    }

    100% {
      transform: translateX(0);
    }
  }
</style>